export default __webpack_public_path__ + "static/media/0xe8d17b127ba8b9899a160d9a07b69bca8e08bfc6.4e3cc0dd.webp";